import { Dialog } from '@material-ui/core';
import CsvImport from 'components/CsvImport/CsvImport';
import SectionsForm from './Forms/SectionsForm';
import OrganizationForm from './Forms/OrganizationForm';
import ManagerForm from './Forms/ManagerForm';
import ApplicantForm from './Forms/ApplicantForm';
import ApplicationManagerConfirmationForm from './Forms/ApplicationManagerConfirmationForm.js';
import UsagePeriodForm from './Forms/UsagePeriodForm';

export default function OrgAdminActionDialog({
  open,
  handleClose,
  organization,
  updateListCallback,
  isEditing,
  dialogType,
  section,
  manager,
  applicant,
  usagePeriod,
  account,
  orgId,
  sectionId,
  uploadType,
  sectionManagerlist,
  titleOptions,
  applicantTitle,
}) {
  const renderDialogContent = () => {
    switch (dialogType) {
      case 'organization':
        return (
          <OrganizationForm
            organization={organization}
            isEditing={isEditing}
            handleClose={handleClose}
            updateListCallback={updateListCallback}
          />
        );
      case 'section':
        return (
          <SectionsForm
            section={section}
            isEditing={isEditing}
            orgId={orgId}
            handleClose={handleClose}
            updateListCallback={updateListCallback}
          />
        );
      case 'manager':
        return (
          <ManagerForm
            manager={manager}
            isEditing={isEditing}
            handleClose={handleClose}
            updateListCallback={updateListCallback}
            sectionId={sectionId}
          />
        );
      case 'applicant':
        return (
          <ApplicantForm
            applicant={applicant}
            isEditing={isEditing}
            handleClose={handleClose}
            updateListCallback={updateListCallback}
            sectionId={sectionId}
            sectionManagerlist={sectionManagerlist}
            section={section}
            titleOptions={titleOptions}
          />
        );
      case 'usagePeriod':
        return (
          <UsagePeriodForm
            usagePeriod={usagePeriod}
            handleClose={handleClose}
            account={account}
            updateListCallback={updateListCallback}
          />
        );
      case 'csv':
        return (
          <CsvImport
            handleClose={handleClose}
            uploadType={uploadType}
            updateListCallback={updateListCallback}
            sectionId={sectionId}
            section={section}
          />
        );
      case 'application':
        return (
          <ApplicationManagerConfirmationForm
            handleClose={handleClose}
            applicant={applicant}
            applicantTitle={applicantTitle}
            updateListCallback={updateListCallback}
            organization={organization}
            section={section}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      {renderDialogContent()}
    </Dialog>
  );
}
